import React, { useEffect, useState } from 'react'
import {
  Table,
  Panel,
  Row,
  Col,
  IconButton,
  Icon,
  Grid,
  Input,
  Message,
  ButtonGroup,
  DatePicker,
} from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import TooltipButton from '../../components/buttons/TooltipButton'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import moment from 'moment'

export default function ManageConsiderationRoundTable({
  schema: _schema,
  errorMsg,
  loading,
  setErrorMsg = () => {},
  onAdd = () => {},
  onSelect = () => {},
  onDelete = () => {},
  handleSearch = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(props?.displayLength || 5)
  const [page, setPage] = useState(props?.page || 1)

  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [name, setName] = useState()

  const [schema, setSchema] = useState(_schema)

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  useEffect(() => {
    setSchema(_schema)
  }, [_schema])

  const handleChangeLength = (dataKey) => {
    console.log('dataKey=', dataKey)
    let req = { endDate: endDate, startDate: startDate, roundName: name }

    setPage(1)
    setDisplayLength(dataKey)
    handleSearch(req, 1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    let req = { endDate: endDate, startDate: startDate, roundName: name }
    handleSearch(req, dataKey, displayLength)
  }

  const onSearch = () => {
    let req = { endDate: endDate, startDate: startDate, roundName: name }
    handleSearch(req, defaultPage, displayLength)
  }

  const onClickClearValue = () => {
    setStartDate('')
    setEndDate('')
    setName('')
    setErrorMsg('')
  }

  return (
    <>
      {schema && (
        <>
          <Grid fluid>
            <Row style={{ marginBottom: 10 }}>
              <Col lg={12} md={12} sm={24} xs={24}>
                ชื่อรอบการพิจารณา
                <Input
                  style={{ width: '100%' }}
                  name={'projectCode'}
                  value={name}
                  placeholder="ระบุชื่อรอบการพิจราณา"
                  onChange={(value) => {
                    setName(value)
                  }}
                ></Input>
              </Col>
            </Row>
            <Row style={{ marginBottom: 10 }}>
              <Col lg={8} md={8} sm={12} xs={24}>
                วันที่เริมต้น
                <DatePicker
                  format={DATE_PICKER_FORMAT}
                  locale={LOCAL_DAY_TH}
                  block
                  placement="auto"
                  value={startDate}
                  style={{ width: '100%' }}
                  placeholder={'วันที่เริมต้น'}
                  onChange={(value) => {
                    setStartDate(value)
                  }}
                />
              </Col>
              <Col lg={8} md={8} sm={12} xs={24}>
                วันที่สิ้นสุด
                <DatePicker
                  format={DATE_PICKER_FORMAT}
                  locale={LOCAL_DAY_TH}
                  block
                  placement="auto"
                  value={endDate}
                  style={{ width: '100%' }}
                  placeholder={'วันที่สิ้นสุด'}
                  onChange={(value) => {
                    setEndDate(value)
                  }}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 20 }}>
              {errorMsg && (
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Message
                    showIcon
                    type="error"
                    description={errorMsg}
                    style={{ marginBottom: 10 }}
                  />
                </Col>
              )}

              <Col xs={24} sm={12} md={4} lg={3}>
                <SaveButton icon="search" block onClick={onSearch} disabled={loading}>
                  {`ค้นหา`}
                </SaveButton>
              </Col>
              <Col xs={24} sm={12} md={4} lg={3}>
                <CancelButton block onClick={onClickClearValue}>
                  {'ล้างข้อมูล'}
                </CancelButton>
              </Col>
            </Row>
          </Grid>
          <hr />

          <SaveButton icon="plus" disabled={loading} onClick={onAdd}>{`เพิ่ม`}</SaveButton>
          <Table
            wordWrap
            bordered
            height={360}
            loading={loading}
            data={schema.values}
            style={{ marginTop: 10 }}
          >
            <Column width={70} align="center" fixed>
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell>
                {(_, index) => {
                  return <>{index + 1}</>
                }}
              </Cell>
            </Column>

            <Column width={220} minWidth={220} flexGrow={1} fixed>
              <HeaderCell>ชื่อรอบการพิจารณา</HeaderCell>
              <Cell dataKey="roundName" />
            </Column>

            <Column width={180} fixed>
              <HeaderCell>วันที่เริมต้น</HeaderCell>
              <Cell dataKey="startDate" />
            </Column>
            <Column width={180} fixed>
              <HeaderCell>วันที่สิ้นสุด</HeaderCell>
              <Cell dataKey="endDate" />
            </Column>
            <Column width={150} fixed align="right">
              <HeaderCell>จำนวนวัน</HeaderCell>
              <Cell>
                {(rowData) => {
                  var stDate = moment(rowData?.startDate, DATE_PICKER_FORMAT).toDate()
                  var enDate = moment(rowData?.endDate, DATE_PICKER_FORMAT).toDate()
                  var diffDate = moment(enDate).diff(moment(stDate), 'days')

                  return <>{diffDate ? diffDate + 1 : diffDate} วัน</>
                }}
              </Cell>
            </Column>
            <Column width={210} fixed>
              <HeaderCell align="center">จัดการ</HeaderCell>
              <Cell align={'center'}>
                {(rowData) => {
                  return (
                    <>
                      <IconButton
                        appearance="ghost"
                        icon={
                          <Icon appearance="ghost" icon="edit" className="bt-gost-icon-radius" />
                        }
                        onClick={() => {
                          onSelect(rowData)
                        }}
                      >
                        แก้ไข
                      </IconButton>
                      <IconButton
                        style={{ marginLeft: 10 }}
                        appearance="ghost"
                        className={'rs-btn-ghost-cancel'}
                        icon={
                          <Icon
                            appearance="ghost"
                            icon="trash-o"
                            className="bt-gost-icon-radius-cancel"
                          />
                        }
                        onClick={() => {
                          onDelete(rowData)
                        }}
                      >
                        ลบ
                      </IconButton>
                    </>
                  )
                }}
              </Cell>
            </Column>
          </Table>

          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={schema.totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        </>
      )}
    </>
  )
}
